<mat-card *appHasRoles="['admin', 'manager', 'agent', 'compliance']" class="content-card">
    <mat-card-header>
        <mat-card-title>
            <h5>Invoices / Annual Fee Deductions</h5>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="list-item" fxLayout="row" fxLayoutGap="10px" >
          <label fxFlex="20" class="secondary">Date</label>
          <label fxFlex="16" class="secondary">Code</label>
          <label fxFlex="15" class="secondary">Type</label>
          <label fxFlex="15" class="secondary">Amount</label>
          <label fxFlex="15" class="secondary">Paid</label>
        </div>
        <div id="scroll">
        <div class="list-item" fxLayout="row" fxLayoutGap="10px" *ngFor="let co of combined" >

          <ng-container *ngIf="co.isInvoice">

              <label [class.archived]="co.invoice.archived" class="" fxFlex="20" >{{ co.invoice.creationDate | date: "dd.MM.yyyy HH:mm" }}</label>
              <label [class.archived]="co.invoice.archived" class="" fxFlex="16" >
                <ng-container *ngIf="co.invoice.debtorDistributionId && !co.invoice.paid" matTooltip="In collection">🔴</ng-container>
                <ng-container *ngIf="co.invoice.paid" matTooltip="Paid">🟢</ng-container>
                <a [class.archived]="co.invoice.archived" routerLink="/invoices/{{ co.invoice.id }}">
                  {{ co.invoice.code }}
                </a>
              </label>
              <label [class.archived]="co.invoice.archived" class="" fxFlex="15" >{{ co.invoice.invoiceTypeName }}</label>
              <label [class.archived]="co.invoice.archived" class="" fxFlex="15" >{{ co.invoice.billAmount.formatMoneyEuro() }}</label>
              <label [class.archived]="co.invoice.archived" class="" fxFlex="15" >{{ co.invoice.paidAmount.formatMoneyEuro() }}</label>

          </ng-container>

          <ng-container *ngIf="co.isAnnualFeeDeduction">
            <label class="" fxFlex="20" >{{ co.annualFeeDeduction.date | date: "dd.MM.yyyy HH:mm" }}</label>
            <label class="" fxFlex="16" >
              <ng-container *ngIf="co.annualFeeDeduction.amountTaken == 0" matTooltip="No payment">⚪️</ng-container>
              <ng-container *ngIf="co.annualFeeDeduction.amount > co.annualFeeDeduction.amountTaken && co.annualFeeDeduction.amountTaken > 0" matTooltip="Paid partly">🟡</ng-container>
              <ng-container *ngIf="co.annualFeeDeduction.amount == co.annualFeeDeduction.amountTaken" matTooltip="Paid in full">🟢</ng-container>
                {{ co.annualFeeDeduction.id }}
            </label>
            <label class="" fxFlex="15" >Annual Fee Deduction</label>
            <label class="" fxFlex="15" >{{ co.annualFeeDeduction.amount.formatMoneyEuro() }}</label>
            <label class="" fxFlex="15" >{{ co.annualFeeDeduction.amountTaken.formatMoneyEuro() }}</label>
          </ng-container>

        </div>
      </div>
    </mat-card-content>
</mat-card>
